<template>
  <div>
    <div align="left">
      <br />
      <h5 class="font-weight-bold text-primary">Paxel Market - SOP</h5>
      <br />
    </div>
    <b-card class="text-left">
      <b>Edit SOP</b>
      <b-row class="mt-4">
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="Title (Bahasa)"
            label-class="control-label"
            class="required"
            label-for="title-id"
          >
            <input
              v-model="item.title.id"
              v-validate="'required'"
              name="title_id"
              data-vv-as="Title Bahasa"
              id="title-id"
              class="form-control"
              placeholder="Title in Bahasa"
            />
            <b-form-invalid-feedback id="input-title_id-feedback">{{
              veeErrors.first("title_id")
            }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="Title (English)"
            label-class="control-label"
            class="required"
            label-for="title-en"
          >
            <input
              v-model="item.title.en"
              v-validate="'required'"
              name="title_en"
              data-vv-as="Title English"
              id="title-en"
              class="form-control"
              placeholder="Title in English"
            />
            <b-form-invalid-feedback id="input-title_en-feedback">{{
              veeErrors.first("title_en")
            }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="Content Value (Bahasa)"
            label-class="control-label"
            class="required"
            label-for="content_value-id"
          >
            <input
              v-model="item.content_value.id"
              v-validate="'required'"
              name="content_value_id"
              data-vv-as="Content Value Bahasa"
              id="content_value-id"
              class="form-control"
              placeholder="Content Value in Bahasa"
            />
            <b-form-invalid-feedback id="input-content_value_id-feedback">{{
              veeErrors.first("content_value_id")
            }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="Content Value (English)"
            label-class="control-label"
            class="required"
            label-for="content_value-en"
          >
            <input
              v-model="item.content_value.en"
              v-validate="'required'"
              name="content_value_en"
              data-vv-as="Content Value English"
              id="content_value-en"
              class="form-control"
              placeholder="Content Value in English"
            />
            <b-form-invalid-feedback id="input-content_value_en-feedback">{{
              veeErrors.first("content_value_en")
            }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group id="fieldset-1" label="Kolom Perubahan" label-for="input-1">
            <b-form-radio-group
              id="radio-group-1"
              v-model="item.is_change"
              :options="optionsChange"
              name="radio-is_change"
              v-validate="'required'"
              data-vv-as="Kolom Perubahan"
            ></b-form-radio-group>
            <p
              class="text-danger"
              style="width:100%;margin-top:.25rem;font-size: 80%;"
            >{{ veeErrors.first('radio-is_change') }}</p>
          </b-form-group>
        </b-col>
      </b-row>
      <div v-if="item.is_change == true" v-for="(row, index) in item.content_change" :key="index" class="mb-3">
        <b-row>
          <b-col md="6">
            <b-form-group
              id="fieldset-1"
              :label="'Content Perubahan (Bahasa) ' + (index + 1)"
              label-class="control-label"
              class="required"
              :label-for="'content_change-id-' + index"
            >
              <textarea
                v-model="row.id"
                v-validate="'required'"
                :name="'content_change_id_' + index"
                :data-vv-as="'Content Perubahan Bahasa ' + (index + 1)"
                :id="'content_change-id-' + index"
                class="form-control"
                placeholder="Content Perubahan in Bahasa"
                rows="3"
              ></textarea>
              <b-form-invalid-feedback :id="'input-content_change_id-feedback-' + index">{{
                veeErrors.first("content_change_id_" + index)
              }}</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              id="fieldset-1"
              :label="'Content Perubahan (English) ' + (index + 1)"
              label-class="control-label"
              class="required"
              :label-for="'content_change-en-' + index"
            >
              <textarea
                v-model="row.en"
                v-validate="'required'"
                :name="'content_change_en_' + index"
                :data-vv-as="'Content Perubahan English ' + (index + 1)"
                :id="'content_change-en-' + index"
                class="form-control"
                placeholder="Content Perubahan in English"
                rows="3"
              ></textarea>
              <b-form-invalid-feedback :id="'input-content_change_en-feedback-' + index">{{
                veeErrors.first("content_change_en_" + index)
              }}</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
            <b-col class="text-right">
                <b-button variant="outline-danger" size="sm" @click="removeRow(index)" v-if="item.content_change.length > 1">Delete Row {{ index + 1 }}</b-button>
            </b-col>
        </b-row>
      </div>
      <b-row v-if="item.is_change == true">
          <b-col>
              <b-button variant="outline-secondary" @click="addRow">+ Row Baru</b-button>
          </b-col>
      </b-row>
      <br v-if="item.is_change == true"/>
      <b-row>
        <b-col>
          <b-form-group id="fieldset-1" label="Status" label-for="input-1">
            <b-form-radio-group
              id="radio-group-2"
              v-model="item.status"
              :options="optionsStatus"
              name="radio-status"
              v-validate="'required'"
              data-vv-as="Status"
            ></b-form-radio-group>
            <p
              class="text-danger"
              style="width:100%;margin-top:.25rem;font-size: 80%;"
            >{{ veeErrors.first('radio-status') }}</p>
          </b-form-group>
        </b-col>
      </b-row>
      <br />
      <b-row class="text-right">
        <b-col md="2" class="text-left">
          <label class="text-danger">
            *
            <b class="text-dark">Required</b>
          </label>
        </b-col>
        <b-col>
          <router-link :to="{ name: 'PaxelMarketSOP' }">
            <b-button :disabled="loading" class="col-2 mr-3" variant="outline-secondary" size="lg">Batal</b-button>
          </router-link>
          <b-button
            variant="primary"
            :disabled="loading"
            @click="put()"
            class="col-2"
            size="lg"
          >
            Simpan
            <b-spinner v-if="loading" small label="Loading..."></b-spinner>
          </b-button>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      item: {
        title: {
          id: "",
          en: ""
        },
        content_value: {
          id: "",
          en: ""
        },
        content_change: [
            {
                id: "",
                en: ""
            }
        ],
        is_change: false,
        status: "",
      },
      optionsStatus: [
        { text: "Publish", value: "publish" },
        { text: "Archive", value: "archive" },
      ],
      optionsChange: [
        { text: "Ya", value: true },
        { text: "Tidak", value: false },
      ],
      loading: false,
    }
  },
  beforeMount() {
    this.$store
        .dispatch("PaxelMarketSOPModule/getSop", this.$route.params.id)
        .then(response => {
          const data = response.data.data
          if(data) {
            // Map API response to local state
            this.item.title = data.title;
            // Handle content mapping based on API response structure (usually "content" object)
            if (data.content) {
                this.item.content_value = data.content;
            } else if (data.content_id) { // Fallback if flat structure
                this.item.content_value = { id: data.content_id, en: data.content_en };
            }

            this.item.status = data.status;
            this.item.is_change = data.change_column; // Map change_column to is_change
            
            // Map content_change Array
            if (data.content_change && Array.isArray(data.content_change)) {
                this.item.content_change = data.content_change;
            } else if (data.content_change) { // Fallback if single object
                 this.item.content_change = [data.content_change];
            } else {
                 this.item.content_change = [{ id: "", en: "" }];
            }

          } else {
            this.$swal({
              type: "error",
              title: "Oops...",
              text: "Your data could not be fetched",
              showConfirmButton: false,
              timer: 1500
            });  
          }
        })
        .catch(error => {
          this.$swal({
            type: "error",
            title: "Oops...",
            text: "Your data data could not be fetched",
            showConfirmButton: false,
            timer: 1500
          });
        });
  },
  methods: {
    addRow() {
        this.item.content_change.push({ id: "", en: "" });
    },
    removeRow(index) {
         this.item.content_change.splice(index, 1);
    },
    put() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.loading = true;
          
           const payload = {
              title_id: this.item.title.id,
              title_en: this.item.title.en,
              content_id: this.item.content_value.id,
              content_en: this.item.content_value.en,
              change_column: this.item.is_change,
              status: this.item.status,
              content_change: this.item.content_change
          };

          this.$store
            .dispatch("PaxelMarketSOPModule/putSop", {
              id: this.$route.params.id,
              formData: payload // Changed to formData to match store action expectation
            })
            .then((response) => {
              this.loading = false;
              this.$router.push({ name: "PaxelMarketSOP" });
              this.$swal({
                type: "success",
                title: "Your work has been saved",
                showConfirmButton: false,
                timer: 1500,
              });
              console.log(response);
            })
            .catch((error) => {
              this.loading = false;
              this.$swal({
                type: "error",
                title: "Oops...",
                text: error.response && error.response.data.message ? error.response.data.message : "An error occurred",
                showConfirmButton: false,
                timer: 1500,
              });
              this.serverError = error.response && error.response.data.message ? error.response.data.message : "An error occurred";
              console.log(error);
            });
        } else {
          this.$swal("ERROR!", "Your data can not be submitted.", "warning");
        }
      });
    },
  }
};
</script>

<style>
</style>
